import modalTemplateUrl from '../views/helpers/placeholder-popup-modal.tpl.html';
import MergeTagModalController from '../controllers/helpers/placeholder-modal-controller';

export default function mergeTagModalCreator($injector, {guestlistId, hideNonGuestlist, scopedGuestlists, entityPrefix}) {
    return $injector.get('$uibModal').open({
        controller: MergeTagModalController,
        controllerAs: 'vm',
        templateUrl: modalTemplateUrl,
        resolve: {
            guestlistId() {
                return guestlistId;
            },
            entityPrefix() {
                return entityPrefix || 'templates';
            },
            hideNonGuestlist() {
                return !!hideNonGuestlist;
            },
            scopedGuestlists() {
                return _.isArray(scopedGuestlists) ? scopedGuestlists : [];
            }
        }
    }).result;
}



// WEBPACK FOOTER //
// ./src/app/modules/merge-tags/helpers/merge-tag-modal-creator.js